import React, { useEffect } from "react";
import theme from "../theme.jsx";
import { makeStyles } from "@mui/styles";
import { toast } from 'react-toastify';
import '../css/ui_shared.css'

import {
	Tooltip,
	Grid,
	Button,
	TextField,
	Typography,
	IconButton,
} from "@mui/material";

import {
	ExpandLess as ExpandLessIcon,
	ExpandMore as ExpandMoreIcon,
	Save as SaveIcon,
} from "@mui/icons-material";

const useStyles = makeStyles({
  notchedOutline: {
    borderColor: "#f85a3e !important",
  },
});

const defaultImage = theme.palette.defaultImage
const OrgHeader = (props) => {
  const {
    userdata,
    selectedOrganization,
    setSelectedOrganization,
    globalUrl,
    isCloud,
		adminTab,
  	handleEditOrg, 
  } = props;

  // const classes = useStyles();

  var upload = "";
  const defaultBranch = "master";
  const [orgName, setOrgName] = React.useState(selectedOrganization.name);
  const [orgDescription, setOrgDescription] = React.useState(
    selectedOrganization.description
  );


  const [file, setFile] = React.useState("");
  const [fileBase64, setFileBase64] = React.useState(
    selectedOrganization.image
  );
  const [expanded, setExpanded] = React.useState(false);

  if (file !== "") {
    const img = document.getElementById("logo");
    var canvas = document.createElement("canvas");
    canvas.width = 174;
    canvas.height = 174;
    var ctx = canvas.getContext("2d");

    img.onload = function () {
      // img, x, y, width, height
      //ctx.drawImage(img, 174, 174)
      //console.log("IMG natural: ", img.naturalWidth, img.naturalHeight)
      //ctx.drawImage(img, 0, 0, 174, 174)
      ctx.drawImage(
        img,
        0,
        0,
        img.width,
        img.height,
        0,
        0,
        canvas.width,
        canvas.height
      );

      const canvasUrl = canvas.toDataURL();
      if (canvasUrl !== fileBase64) {
        setFileBase64(canvasUrl);
        selectedOrganization.image = canvasUrl;
        setSelectedOrganization(selectedOrganization);
      }
    };
  }


  var image = "";
  const editHeaderImage = (event) => {
    const file = event.target.value;
    const actualFile = event.target.files[0];
    const fileObject = URL.createObjectURL(actualFile);
    setFile(fileObject);
  };

  //console.log("USER: ", userdata)
  const orgSaveButton = (
    <Tooltip title="Save any unsaved data" placement="bottom">
      <Button
        id="button-1-orgsavebutton-organizationheader-page"
        style={{
          width: 150,
          height: 50,
          flex: 1,
          backgroundColor: '#FF6600',
          color: 'white',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '8px', // spacing between icon and text
        }}
        variant="outlined"
        color="primary"
        disabled={
          userdata === undefined ||
          userdata === null ||
          userdata.admin !== "true"
        }
        onClick={() =>
          handleEditOrg(
            orgName,
            orgDescription,
            selectedOrganization.id,
            selectedOrganization.image,
            {
              app_download_repo:
                selectedOrganization?.defaults?.app_download_repo,
              app_download_branch:
                selectedOrganization?.defaults?.app_download_branch,
              workflow_download_repo:
                selectedOrganization?.defaults?.workflow_download_repo,
              workflow_download_branch:
                selectedOrganization?.defaults?.workflow_download_branch,
              notification_workflow:
                selectedOrganization?.defaults?.notification_workflow,
              documentation_reference:
                selectedOrganization?.defaults?.documentation_reference,
              workflow_upload_repo:
                selectedOrganization?.defaults?.workflow_upload_repo,
              workflow_upload_branch:
                selectedOrganization?.defaults?.workflow_upload_branch,
              workflow_upload_username:
                selectedOrganization?.defaults?.workflow_upload_username,
              workflow_upload_token:
                selectedOrganization?.defaults?.workflow_upload_token,
              newsletter: selectedOrganization?.defaults?.newsletter,
              weekly_recommendations:
                selectedOrganization?.defaults?.weekly_recommendations,
            },
            {
              sso_entrypoint:
                selectedOrganization?.sso_config?.sso_entrypoint,
              sso_certificate:
                selectedOrganization?.sso_config?.sso_certificate,
              client_id: selectedOrganization?.sso_config?.client_id,
              client_secret: selectedOrganization?.sso_config?.client_secret,
              openid_authorization:
                selectedOrganization?.sso_config?.openid_authorization,
              openid_token: selectedOrganization?.sso_config?.openid_token,
              SSORequired: selectedOrganization?.sso_config?.SSORequired,
              auto_provision:
                selectedOrganization?.sso_config?.auto_provision,
            },
            []
          )
        }
      >
        {/* SVG Icon */}
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15.3337 3.80438V13.8529C15.3337 14.2745 15.1925 14.6268 14.9102 14.9098C14.6278 15.1927 14.2752 15.3339 13.8523 15.3333H2.14833C1.72605 15.3333 1.37374 15.1921 1.09141 14.9098C0.809075 14.6275 0.667603 14.2748 0.666992 13.852V2.14796C0.666992 1.72568 0.808464 1.37338 1.09141 1.09104C1.37435 0.808709 1.72666 0.667237 2.14833 0.666626H12.1959L15.3337 3.80438ZM14.417 4.19579L11.8045 1.58329H2.14833C1.98333 1.58329 1.84796 1.63615 1.74224 1.74188C1.63652 1.8476 1.58366 1.98296 1.58366 2.14796V13.8529C1.58366 14.0173 1.63652 14.1523 1.74224 14.258C1.84796 14.3638 1.98333 14.4166 2.14833 14.4166H13.8532C14.0176 14.4166 14.1527 14.3638 14.2584 14.258C14.3641 14.1523 14.417 14.017 14.417 13.852V4.19579ZM8.00033 12.1598C8.50571 12.1598 8.93777 11.9807 9.29649 11.6226C9.65521 11.2645 9.83427 10.8325 9.83366 10.3265C9.83305 9.82046 9.65369 9.38871 9.29558 9.03121C8.93746 8.67371 8.50571 8.49465 8.00033 8.49404C7.49494 8.49343 7.06319 8.67249 6.70508 9.03121C6.34696 9.38993 6.1676 9.82168 6.16699 10.3265C6.16638 10.8312 6.34574 11.2633 6.70508 11.6226C7.06441 11.982 7.49616 12.161 8.00033 12.1598ZM3.20616 5.95579H10.0097V3.20579H3.20616V5.95579ZM1.58366 4.19579V14.4166V1.58329V4.19579Z"
            fill="white"
          />
        </svg>
  
        Save
      </Button>
    </Tooltip>
  );
  

  var imageData = file.length > 0 ? file : fileBase64;
imageData = imageData === undefined || imageData.length === 0 ? defaultImage : imageData;

const imageInfo = (
  <div id="image-container">
  <svg
    width="60"
    height="60"
    viewBox="0 0 60 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    id="placeholder-svg"
  >
    <path d="M6.69117 59.6864C4.99392 59.6864 3.57792 59.1191 2.44314 57.9843C1.30837 56.8495 0.739761 55.4323 0.737305 53.7326V6.69117C0.737305 4.99392 1.30592 3.57792 2.44314 2.44314C3.58037 1.30837 4.99638 0.739761 6.69117 0.737305H53.7363C55.4311 0.737305 56.8471 1.30592 57.9843 2.44314C59.1215 3.58037 59.6889 4.99638 59.6864 6.69117V53.7363C59.6864 55.4311 59.1191 56.8471 57.9843 57.9843C56.8495 59.1215 55.4323 59.6889 53.7326 59.6864H6.69117ZM6.69117 56.0021H53.7363C54.3012 56.0021 54.8207 55.7663 55.2947 55.2947C55.7688 54.8231 56.0046 54.3024 56.0021 53.7326V6.69117C56.0021 6.12378 55.7663 5.60307 55.2947 5.12902C54.8231 4.65497 54.3024 4.41917 53.7326 4.42163H6.69117C6.12378 4.42163 5.60307 4.65742 5.12902 5.12902C4.65497 5.60061 4.41917 6.12133 4.42163 6.69117V53.7363C4.42163 54.3012 4.65742 54.8207 5.12902 55.2947C5.60061 55.7688 6.1201 56.0046 6.68748 56.0021M13.6324 46.7913H47.3587L36.9431 32.9014L27.3086 45.0892L20.8611 37.2968L13.6324 46.7913Z" fill="#A0A0A0"/>
  </svg>
</div>

);

const useStyles = makeStyles({
  notchedOutline: {
    borderColor: '#545454 !important',
  },
});
const classes = useStyles();


  return (
    <div>
      <div
        id="container-1-organizationheader-page" style={{
          color: "white",
          flex: "1",
          display: "flex",
          flexDirection: "row",
        }}
      >
        <Tooltip
          title="Click to edit the organizations's image (174x174)"
          placement="bottom"
        >
          <div
            id="container-2-organizationheader-page" style={{
              flex: "1",
              margin: "10px 25px 10px 0px",
              border:
                imageData !== undefined && imageData.length > 0
                  ? null
                  : "1px solid #f85a3e",
              cursor: "pointer",
              maxWidth: 174,
              maxHeight: 174,
			  borderRadius: theme.shape.borderRadius,
            }}
            onClick={() => {
              upload.click();
            }}
          >
            <input
              hidden
              type="file"
              ref={(ref) => (upload = ref)}
              onChange={editHeaderImage}
            />
            {imageInfo}
          </div>
        </Tooltip>
        <div id="container-3-organizationheader-page" style={{ flex: "3", color: "white", display: "flex", flexDirection: "column" }}>
  {/* Row: Inputs */}
  <div id="container-6-organizationheader-page" style={{ display: "flex", alignItems: "flex-start" }}>
    {/* Name input */}
    <div style={{ flex: 1, marginRight: "15px" }}>
      <div style={{ marginBottom: "5px" }}>Name</div>
      <TextField
        required
        style={{
          backgroundColor: '#2f2f2f',
        }}
        fullWidth
        placeholder="Name"
        type="name"
        id="standard-required"
        margin="normal"
        variant="outlined"
        value={orgName}
        onChange={(e) => {
          const invalid = ["#", ":", "."];
          for (var key in invalid) {
            if (e.target.value.includes(invalid[key])) {
              toast("Can't use " + invalid[key] + " in name");
              return;
            }
          }

          if (e.target.value.length > 100) {
            toast("Choose a shorter name.");
            return;
          }

          setOrgName(e.target.value);
        }}
        color="primary"
        InputProps={{
          style: {
            color: "white",
            height: "50px",
            fontSize: "1em",
          },
          classes: {
            notchedOutline: classes.notchedOutline,
          },
        }}
      />
    </div>

    {/* Description input */}
    <div style={{ flex: 2 }}>
      <div style={{ marginBottom: "5px" }}>Description</div>
      <TextField
        required
        style={{
          backgroundColor: '#2f2f2f',
        }}
        fullWidth
        type="text"
        id="outlined-with-placeholder"
        margin="normal"
        variant="outlined"
        placeholder="A description for the organization"
        value={orgDescription}
        onChange={(e) => {
          setOrgDescription(e.target.value);
        }}
        InputProps={{
          classes: {
            notchedOutline: classes.notchedOutline,
          },
          style: {
            color: "white",
            height: "50px",
          },
        }}
      />
    </div>
  </div>

  {/* Row: Save Button */}
  <div id="container-7-organizationheader-page" style={{ marginTop: "10px" }}>
    {orgSaveButton}
  </div>
</div>

      </div>
    </div>
  );
};

export default OrgHeader;
